module.exports = "<div class=\"header\">{{ modal.context.title }}</div>\n<div class=\"content\">\n    <p>{{ modal.context.question }}</p>\n</div>\n<div class=\"actions\">\n    <button class=\"ui red button\" (click)=\"modal.deny(undefined)\">Annuler</button>\n    <button class=\"ui green button\" (click)=\"modal.approve(undefined)\">OK</button>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/confirm-modal/confirm-modal.component.html
// module id = 1003
// module chunks = 0